import { enumToOption } from '@/utils'

// 通知类型
export enum NotificationType {
  升级公告 = 1,
  通知 = 2,
  公告 = 3
}

export const notificationTypeOpt = enumToOption(NotificationType)

// 状态
export enum Status {
  开启 = 1,
  关闭 = 0
}

export const statusOpt = enumToOption(Status)

// 范围
export enum Scope {
  公开 = 1,
  白名单 = 2,
  黑名单 = 3
}

export const scopeOpt = enumToOption(Scope)

export const getTableConfig = () => {
  const common = {
    isSelection: false,
    loading: false,
    stripe: true,
    isIndex: true,
    indexLabel: '序号',
    size: 'small',
    data: []
  }

  const pagination = {
    isShow: true,
    total: 0,
    pageSize: 20,
    currentPage: 1,
    pageSizes: [10, 20, 40, 80, 100]
  }

  const column = [
    {
      key: 'noticeType',
      label: '类型',
      width: '100',
      formatter: (row: any, column: any, val: number) => NotificationType[val] || '-'
    },
    {
      key: 'content',
      label: '内容',
      width: '300',
      formatter: (row: any) => {
        const content = row.content || ''
        return content.length > 20 ? content.substring(0, 20) + '...' : content
      }
    },
    {
      key: 'redirectUrl',
      label: '详情 URL',
      width: '150'
    },
    {
      key: 'expireTime',
      label: '截止有效日期',
      width: '160'
    },
    {
      key: 'state',
      label: '状态',
      width: '80',
      formatter: (row: any, column: any, val: number) => Status[val] || '-'
    },
    {
      key: 'filterRule',
      label: '范围',
      width: '140',
      formatter: (row: any, column: any, val: number) => Scope[val] || '-'
    },
    {
      key: 'createTime',
      label: '创建日期时间',
      width: '160'
    },
    {
      key: 'updateTime',
      label: '更新日期时间',
      width: '160'
    },
    {
      key: 'action',
      label: '操作',
      width: '140',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

export const getIndexConfig = () => {
  const inputList = [
    {
      type: 'select',
      label: '类型',
      key: 'type',
      placeholder: '请选择',
      options: notificationTypeOpt,
      labelWidth: 100,
      inputWidth: 200
    },
    {
      type: 'select',
      label: '状态',
      key: 'status',
      placeholder: '请选择',
      options: statusOpt,
      labelWidth: 100,
      inputWidth: 200
    },
    {
      type: 'input',
      label: '内容',
      key: 'content',
      placeholder: '模糊匹配 0-10 个字',
      labelWidth: 100,
      inputWidth: 200,
      maxlength: 10
    }
  ]

  return {
    queryForm: {
      type: '',
      status: '',
      content: ''
    },
    inputList
  }
}
